module.exports = __webpack_public_path__ + "img/accessibility.43600d3d.svg";